module.exports = __webpack_public_path__ + "img/cuadros-de-paisajes.82e51ded.png";